import { useState, useEffect } from 'react'

import ListProject from './ListProject';
import service from '../../services/citizenScienceService';
import { recordError } from "../../utils/logService";

export default function ProjectView() {

    const defaultTitle = "List";

    const [visible, setVisible] = useState(false);
    const [hasUpdated, setHasUpdated] = useState(false);
    const [modalType, setModalType] = useState("add");
    const [statuses, setStatuses] = useState([]);
    const [defaultStatus, setDefaultStatus] = useState();
    const [mainTitle, setMainTitle] = useState(defaultTitle);

    useEffect(() => {
        getProjectStatus();        
    }, [])

    const showModal = (record, type) => {
        setVisible(record);
        setModalType(type)
    };

    const getProjectStatus = async () => {
        try {
            const response = await service.getProjectStatus();
            
            var statusData = [];
            if (response && response.status === 200) {
                const { data } = response;
                data.sort((a, b) => a.key - b.key);
                
                statusData = data.map((status) => ({
                    key: status.key,
                    label: status.value,
                }));
                setDefaultStatus(data[0]);
                setStatuses(statusData);
                setHasUpdated(true);
                // getProjectsByStatus({ statusKey: data[0].key });
            }
            else {
                setDefaultStatus({});
            }
        } catch (error) {
            recordError(error);
        }
    };

    return (
        <div>
            {statuses.length > 0 ? 
                <ListProject key={"ListProject-1"} defaultStatus={defaultStatus} statuses={statuses} hasUpdated={hasUpdated} />
                : ""    
            }
        </div>
    )
}
